import { inject } from '@angular/core';
import { RedirectFunction } from '@angular/router';

import { isSemrushUpgradeOffer } from './semrush.helpers';
import { SemrushService } from './services/semrush.service';

export const redirectToHomeWithSemrushUpgradeOffer: RedirectFunction = (route) => {
    if (isSemrushUpgradeOffer(route.data)) {
        inject(SemrushService).setPendingUpgradeOffer({
            upgradeFrom: route.data.upgradeFrom,
            upgradeTo: route.data.upgradeTo,
        });
    }

    return '/';
};
